import React from 'react';
import PropTypes from 'prop-types';

const DancePath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12.63 6.486c-3.91-.318-6.6 8.341-7.028 9.714-.356 1.141-4.176 13.957 1.424 14.557 7.404.796 10.118-23.907 5.604-24.271zM9.304 27.16c-1.137-1.737-2.207-.977-2.796-.47-.588.505-1.011-.377-.627-.73 2.992-2.973 3.953-.122 4.384.631.432.75-.757 1.04-.96.569zm1.95-3.745c-.69.368-4.922-.122-4.985-1.09-.443-1.051.682-7.42 3.498-11.977 2.655-4.295 3.079-.773 3.232.615.404 3.616-.82 11.962-1.745 12.452zm13.714-12.887c-.612-1.302-4.342-9.31-8.173-8.467-4.424.973 1.604 25.08 8.832 23.295 5.467-1.353-.153-13.746-.66-14.828zm-4.545 7.957c-.985-.365-3.31-9.204-3.389-11.938-.043-1.396-.09-4.945 3.118-1.047 3.404 4.138 5.38 10.295 5.082 11.397.071.969-4.078 1.859-4.811 1.588zm5.164 2.769c-.65-.42-1.815-1.028-2.71.847-.14.494-1.356.369-1.027-.435.33-.804.89-3.757 4.259-1.216.431.29.133 1.224-.522.804z"
    />
  );
};

DancePath.propTypes = {
  fill: PropTypes.string,
};

export default DancePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/dance.jsx